// extracted by mini-css-extract-plugin
export default {"container":"styles_container__qDLlw","content":"styles_content__207Rf","number":"styles_number__U7awG","text":"styles_text__Z78dd"};